"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var styles_less_1 = __importDefault(require("./styles.less"));
var StreamingServerUrlModal = function (_a) {
    var url = _a.url, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var t = (0, react_i18next_1.useTranslation)().t;
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        event.stopPropagation();
        if (event.key === 'Escape') {
            event.preventDefault();
            onCancel();
        }
    }, [onCancel]);
    (0, react_1.useEffect)(function () {
        var onWindowKeyDown = function (event) {
            event.key === 'Escape' && onCancel();
        };
        window.addEventListener('keydown', onWindowKeyDown);
        return function () { return window.removeEventListener('keydown', onWindowKeyDown); };
    }, [onCancel]);
    return (0, react_dom_1.createPortal)((react_1.default.createElement(react_focus_lock_1.default, { autoFocus: false, returnFocus: true, className: styles_less_1.default['modal-container'], lockProps: { onKeyDown: onKeyDown } },
        react_1.default.createElement("div", { className: styles_less_1.default['backdrop'], onClick: onCancel }),
        react_1.default.createElement("div", { className: styles_less_1.default['modal-dialog-container'], role: 'dialog', "aria-modal": 'true', "aria-labelledby": 'streaming-server-url-modal-title' },
            react_1.default.createElement(components_1.Button, { className: styles_less_1.default['close-button-container'], title: t('BUTTON_CLOSE'), onClick: onCancel },
                react_1.default.createElement(react_2.default, { className: styles_less_1.default['icon'], name: 'close' })),
            react_1.default.createElement("div", { className: styles_less_1.default['modal-dialog-content'] },
                react_1.default.createElement("div", { id: 'streaming-server-url-modal-title', className: styles_less_1.default['title-container'], title: t('SETTINGS_SERVER_CONFIGURE_TITLE') }, t('SETTINGS_SERVER_CONFIGURE_TITLE')),
                react_1.default.createElement("div", { className: styles_less_1.default['body-container'] },
                    react_1.default.createElement("div", { className: styles_less_1.default['url'] }, url)),
                react_1.default.createElement("div", { className: styles_less_1.default['buttons-container'] },
                    react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(styles_less_1.default['action-button'], styles_less_1.default['cancel-button']), title: t('BUTTON_CANCEL'), onClick: onCancel },
                        react_1.default.createElement("div", { className: styles_less_1.default['label'] }, t('BUTTON_CANCEL'))),
                    react_1.default.createElement(components_1.Button, { className: styles_less_1.default['action-button'], title: t('BUTTON_CONFIRM'), onClick: onConfirm },
                        react_1.default.createElement("div", { className: styles_less_1.default['label'] }, t('BUTTON_CONFIRM')))))))), document.body);
};
exports.default = StreamingServerUrlModal;
